<template>
	<div id="newsDetail" data-role="page">
		<!-- content -->
		<div class="newsDetail-content" data-position="fixed">
			<div class="detailWrap">
                <div class="detail-h">
					<span class="cgy-tag">{{chn_tag(News.news_type)}}</span>
					<h3 :class="{'LargSize':fz_larg}">{{News.title}}</h3>
					<span class="article_date" :class="{'LargSize':fz_larg}">{{News.news_date}}</span>
				</div>
				<!-- 文章內容 -->
                <div class="detail-c">
					<div class="mainImg" :style="'background-image:url('+News.title_img+')'" v-if="News.title_img != ''"></div>
                    <div class="mainImg" v-if="News.title_img == ''"></div>
                    <div class="txtContent" :class="{'LargSize':fz_larg}">
						<p v-html="News.content"></p>
						<!-- <a href="https://www.kingnet-select.com.tw/isp_v3/ispform.html" target="_blank">文章內文連結顏色樣式</a>
						<img src="https://fakeimg.pl/900x675/cccccc/" alt=""> -->
					</div>
				</div>
				<!-- /文章內容 -->
				<!-- 公寓管理條例相關法條 -->
				<div class="detail-ref" v-if="MoreNewsRule.length !=0">
					<h4><i class="icon-article-pen"></i>公寓大廈管理條例相關法條</h4>
					<ul>
						<li v-for="(rule,rule_ind) in MoreNewsRule" :key="rule_ind"><router-link :to="{name:'legalRuleDetail', params:{ id:rule.rule_id}}">{{rule.rule_name}}</router-link></li>
					</ul>
				</div>
				<!-- /公寓管理條例相關法條 -->
				<!-- 熱門主題標籤 -->
				<div class="detail-hashtag" style='display:none;'>
					<ul>
						<li v-for="(tag,tag_ind) in Tags" :key="tag_ind">#{{tag.tag_name}}</li>
					</ul>
				</div>
				<!-- /熱門主題標籤 -->
				<!-- 文章來源 -->
				<!-- <div class="detail-source">
					<h4>文章來源</h4>
					<div class="logowrap">
                        <router-link :to="{name:'newsSource' , params: {id:News.legal_id}}">
                            <img :src="'https://storage.googleapis.com/kingnetcare/CHK/committee/official/'+News.legal_id+'/logo.jpg'" alt="">
                            <div>
                                <p class="s-name">{{News.legal_name}}</p>
                                <span class="s-more">瞭解更多</span>
                            </div>
                        </router-link>
					</div>
					<div class="descwrap">
						{{News.about}}
					</div>
				</div> -->
				<!-- /文章來源 -->
                <div class="detail-source">
                    <h4>文章來源</h4>
                    <div class="logowrap">  
                        <p class="s-name">{{News.legal_name}}</p>
                        <div class="logoImg" v-if="News.legal_logo != null">
                            <img :src="News.legal_logo" alt="">
                        </div>
                    </div>
                    <div class="descwrap">
						{{News.about}}
                        <span class="more" 
                            v-if="News.multiLink != null && News.multiLink.length > 0" 
                            v-on:click.prevent="windowsOpen(News.multiLink[0].link)"> <<查看更多 </span>
					</div>
                </div>
			</div>
            <!--問卷-->
            <div class="detailWrap articleWrap questionnaire">
                <div class="detail-c">
					<div class="questionnaire">
                        <a href="https://docs.google.com/forms/d/e/1FAIpQLSetKmRasOJyXyx4XNOt8g_bFeUpytB5dTVdzRnPkAhAN_Ezzg/viewform">
                            <div class="img">
                            </div>
                            <div class="txt">
                                <span class="title">想看什麼快來許願吧！</span>
                                <p class="content">不管你想看甚麼,我們都幫你準備。</p>
                            </div>
                        </a>
                    </div>
                </div>
			</div>          
            <!--/問卷-->
			<!-- 相關文章 -->
            <div class="detailWrap articleWrap" v-if="MoreNews.length>1">
                <div class="detail-c">
                    <h4 class="cgyTitle"><i class="titleIcon icon-article-pen"></i>相關文章</h4>
                    <a v-on:click="ClaenGotoNewsPage(News.news_type)" v-if="Authority" ><span class="moreBtn-rt">查看更多 ></span></a>
					<div class="cgyContent">
                        <div class="articleList">
                            <ul>
                                <li v-for="(MoreNews,MoreNews_ind) in MoreNews" :key="MoreNews_ind" v-if="$route.params.id != MoreNews.news_id">
                                    <a v-on:click="nextPage(MoreNews.news_id)">
                                    <!-- <router-link :to="{name: 'newsDetail',params:{id:MoreNews.news_id}}"> -->
                                        <!-- <img :src="MoreNews.title_img" alt="" class="topicImg">
                                        <img src="../assets/Default.jpg" alt="" class="topicImg" v-if="MoreNews.title_img == '' || MoreNews.title_img == null"> -->
                                        <div class="topicImg">
                                            <div class="mainImg" v-lazy:background-image="MoreNews.title_img" v-if="MoreNews.title_img != ''"></div>
                                            <div class="mainImg" v-if="MoreNews.title_img == ''"></div>
                                        </div>
                                        <div class="txt-info">
                                            <span class="article_desc">{{MoreNews.title}}</span>
                                            <span class="article_date">{{MoreNews.news_date.split(" ")[0]}}</span>
                                            <div class="metaDiv">
                                                <span class="cgy-tag">{{chn_tag(MoreNews.news_type)}}</span>
                                                <span v-if="Authority" class="bookmark-tag" v-on:click.prevent="SetFavorites(MoreNews.news_id,MoreNews.is_keep)"><i :class="[MoreNews.is_keep? 'icon-bookmark-full bookmarkIcon active':'icon-bookmark bookmarkIcon']"></i></span>
                                            </div>
                                        </div>
                                    </a>    
                                    <!-- </router-link> -->
                                </li>
                            </ul>
                            <!-- <p class="moreBtn" v-if="MoreNews_row<=this.MoreNews.length && this.MoreNews.length >=10">載入更多</p> -->
                            <div class="moreBtn" v-if="MoreNews_row<=this.MoreNews.length && this.MoreNews.length >=10">
                                <p class="loading-rotate"></p>
                                <p class="loading-tip">載入更多</p>
                            </div>
                        </div>
                    </div>
                </div>
			</div>
			<!-- /相關文章 -->
		</div>
		<!-- /content -->
        <!-- footer -->
        <div class="qk-functionBar active" v-if="Authority">
            <div :class="[Authority? 'qk-functionBar-wrap-col4':'qk-functionBar-wrap-col1']">
				<div v-on:click="SetRecommend(News.news_id,News.is_push)"><span><i :class="[ News.is_push ? 'icon-smile-full active':'icon-smile']"></i>推</span></div>
                <div v-on:click="SetFavorites(News.news_id,News.is_keep)"><span><i :class="[ News.is_keep ? 'icon-bookmark-full bookmarkIcon active':'icon-bookmark bookmarkIcon']"></i>收藏</span></div>
                <div v-on:click="ChanegSize"><span><i class="icon-letterA"></i>大小</span></div>
                <div v-on:click="Share(News.news_id,News.title)"><span><i class="icon-share"></i>分享</span></div>
            </div>               
        </div>
        <!-- /footer -->

        <favoritesToast
        :show="toastControl.show"
        :full="toastControl.full"
        :content="toastControl.content"
        :showTime="toastControl.showTime"
        @close="toastControl.show = false"
        ></favoritesToast>
	</div>  
</template>

<script lang="js">
var vobj=this;
import favoritesToast from '@/components/common/toast/favoritesToast';
export default {
    components: { favoritesToast },
  data () {
    return {
        News:{},//新聞內容
        NewsType:[],
        Imgurl: Imgurl,
        MoreNews:[],//相關文章列表
        MoreNewsRule:[],//新聞相對映法條
        Tags:[],
        scrollPrevioustTicks:0,
        fz_larg: false,
        Authority: false,
        MoreNews_row:11,
        toastControl:{
            show: false,
            full: false,
            content: '',
            showTime: 1000
        }
    }
  },
  mounted(){
    this.GetNewsDetail();
    this.CheckAuthority();
    window.addEventListener('scroll', this.handleScroll);
  },
  activated(){ 

  },
  methods:{
      //底部功能表示窗滾動事件
      handleScroll () {
        let scrollBottom = $(document).height() - $(window).height() - $(window).scrollTop();

        if(scrollBottom < 100 && this.MoreNews_row<=this.MoreNews.length && this.MoreNews.length >=10){
            this.ShowMoreNews()
        }


        if(this.scrollPrevioustTicks<window.scrollY){
            //向下滑動
            $('.qk-functionBar').removeClass('active')
            if(scrollBottom == 0){$('.qk-functionBar').addClass('active')} 
        }else if(this.scrollPrevioustTicks>window.scrollY){
            //向上滑動
            $('.qk-functionBar').addClass('active')
        }
        this.scrollPrevioustTicks = window.scrollY;
      },
      //取得新聞詳細名單
      GetNewsDetail(){
        let news_id = typeof this.$route.params.id == 'number' ?  this.$route.params.id :  decodeURIComponent(this.$route.params.id).split('-')[0]
        let vobj = this;
        this.axios.get(`${process.env.ExternalApi}/api/ExternalControllers/Committee/GetCommitteeNewsContent/${news_id}`,{
            headers:{Authorization: Token,}
        }).then((response) => {
            if(response.status == 200){
                // window.document.title = response.data.data.type_name  //標題
                this.News =  response.data.data
                // this.News.legal_logo = `http://file.kingnetsmart.com.tw/CHK/committee/official/${ this.News.legal_id }/logo.jpg`
                this.News['news_date']=this.News['news_date'].split(' ')[0];
                this.GetnMoreNews();
                this.GetNewsRule();
                this.GetTag();
                this.GetNewsType();
            }
        }).catch(function (error) {
            vobj.GetNewsDetail();
        });     
      },
      //取得更多新聞列表
      GetnMoreNews(){
        let vobj = this;
        this.axios.get(`${process.env.ExternalApi}/api/ExternalControllers/Committee/GetRelatedCommitteeNews/${this.News.news_type}`,{
            headers:{Authorization: Token},
            params: {
                page: 1,
                row: this.MoreNews_row
            }
        }).then((response) => {
            if(response.status == 200){
                this.MoreNews =  response.data.data
            }
        }).catch(function (error) {
            vobj.GetnMoreNews();
        });                  
      },
      //取的新聞的相對映法條
      GetNewsRule(){
        let news_id = typeof this.$route.params.id == 'number' ?  this.$route.params.id :  decodeURIComponent(this.$route.params.id).split('-')[0]
        let vobj = this;
        this.axios.get(`${process.env.ExternalApi}/api/ExternalControllers/Committee/GetNewsDependLegalRule/${news_id}`,{
            headers:{Authorization: Token}
        }).then((response) => {
            if(response.status == 200){
                this.MoreNewsRule =  response.data.data
            }
        }).catch(function (error) {
            vobj.GetNewsRule();
        })   
      },
      //取得＃字標籤
      GetTag(){
        let news_id = typeof this.$route.params.id == 'number' ?  this.$route.params.id :  decodeURIComponent(this.$route.params.id).split('-')[0]
        let vobj = this;
        this.axios.get(`${process.env.ExternalApi}/api/ExternalControllers/Committee/GetNewsDependTagInfo/${news_id}`,{
            headers:{Authorization: Token}
        }).then((response) => {
            if(response.status == 200){
                this.Tags =  response.data.data
            }
        }).catch(function (error) {
            vobj.GetTag();
        })      
      },
     //取得新聞標籤
     GetNewsType(functions){
       let vobj = this;
       vobj.axios.get(`${process.env.ExternalApi}/api/ExternalControllers/Committee/GetCommitteeNewsType`).then((response) => {
            vobj.NewsType=response.data.data
       })
     },      
      //回傳標籤名稱
      chn_tag(news_type){
        let flag='';
        this.NewsType.map(tag => {
            if(tag.type_id == news_type){flag = tag.type_name}
        });
        return flag;
      },
      //設定收藏
      SetFavorites(id,status){
          let vobj = this;
          if(vobj.toastControl.show) return false
          let status_val = 0;
          status ? (status_val=0 ) : (status_val=1);
          vobj.$root.SetFavorites(0,id,status_val,function(res){
              if(res){
                  vobj.MoreNews.map((val,ind)=>{
                      if(val.news_id == id){
                          vobj.MoreNews[ind]['is_keep'] = status ? (false):(true);
                      }
                  })
                  status ? vobj.UnfavoritesToast() : vobj.FavoritesToast()
                  if(vobj.News['news_id'] == id){
                      vobj.News['is_keep'] = status ? (false):(true);
                  }
              }
          });
      },
      //設定推
      SetRecommend(id,status){
          let vobj = this;
          let status_val = 0;
          status ? (status_val=0 ) : (status_val=1);
          vobj.$root.SetRecommend(0,id,status_val,function(res){
              if(res){
                vobj.News['is_push'] = status ? (false):(true);
              }
          });
      },
      //文字大小變化
      ChanegSize(){
          this.fz_larg? this.fz_larg=false:this.fz_larg=true;
      },
      //分享按鈕     
      Share(id,title){
          document.location.href='#/newsDetail/'+id+"-"+ encodeURIComponent(title)+"?mode=share"
      },
      //檢查權限
      CheckAuthority(){
          if(localStorage.getItem("token")=='' || localStorage.getItem("token") == null){
              this.Authority= false
          }else{
              this.Authority= true
          }
      },
      //顯示更多相關新文
      ShowMoreNews(){
          this.MoreNews_row +=10;
          this.GetnMoreNews();
      },
      //清空GotoNewsPage值
      ClaenGotoNewsPage(news_type){
          window.localStorage.setItem('GotoNewsPage','')
          document.location.href = '#/news/?news_type='+news_type
      },
        FavoritesToast(){
            this.toastControl.content = '已加入收藏'
            this.toastControl.full = true
            this.toastControl.show = true
        },
        UnfavoritesToast(){
            this.toastControl.content = '已取消收藏'
            this.toastControl.full = false
            this.toastControl.show = true
        },
        windowsOpen(url){
            jQuery('body').append(`
                <div class="overlayBG on">
                    <div class="s-loading">
                        <div class="loader"></div>
                    </div>
                </div>
            `)
            window.open(url,'_system');
        },
        nextPage(id){
          // this.$route.meta.keepAlive = false
          document.location.href = '#/newsDetail/'+id
          console.log(this.$route)
          
          //如果為前往頁面時 需將頁面置頂 如為反回則照keepalive特性
          $('html,body').scrollTop(0);
        }
  },
  watch: {
      '$route' (to, from) {

        if(to.name == "newsDetail"){
          this.GetNewsDetail();
        }
        
        // $('html,body').scrollTop(0);
      }
  },
}
</script>


// WEBPACK FOOTER //
// src/components/newsDetail.vue